import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 0.625rem;

  & > img {
    width: 65px;
    height: 65px;

    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
  } 

  @media only screen and (max-width: 1050px) {

    & > img {
        width: 50px;
        height: 50px;
    }
  }

  @media only screen and (max-width: 768px) { //1061
    padding: 0;
  }
`;

export const Title = styled.p`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.875rem;
  line-height: 1rem;

  color: #0E4C54;
  padding: 2.5rem 0;

  @media only screen and (max-width: 1080px) {
    font-size: 1.375rem;
  }

  @media only screen and (max-width: 900px) {
    font-size: 1.125rem
  }
`;

export const Content = styled.div`
  display: grid;
  justify-content: start;
  padding-top: 0.938rem;

  @media only screen and (max-width: 1200px) {
    padding-top: 0;
  }
`;

export const Button = styled.button`
  box-sizing: border-box;

  width: 760px;
  height: 80px;

  background: #FFFFFF;
  border: 2px solid #6EE1DC;
  border-radius: 31.25rem;

  font-style: normal;
  font-weight: 800;
  font-size: 25px;
  line-height: 3.75rem;

  text-align: center;

  color: #7E8081;

  &:not(:first-of-type) {
    margin-top: 0.625rem;
  }

  &:hover {
    background: #d5f6f5;
  }
  
  @media only screen and (max-width: 1200px) {
    width: 570px;
    height: 70px;
    font-size: 1.563rem;
  }

  @media only screen and (max-width: 1080px) {
    width: 450px;
    height: 60px;
    font-size: 1.25rem;
    line-height: 0;
  }

  @media only screen and (max-width: 900px) {
    width: 360px;
    height: 55px;
    font-size: 0.938rem;
  }
`;
